import React from "react"
import * as svg from "./svg"
import * as theme from "layouts/theme"
import * as containers from "layouts/containers"

const Icon = (props: svg.SVGProps) => {
	const { fill, stroke, ...rest } = props
	return (
		<svg.SVG
			width="17"
			height="17"
			viewBox="0 0 17 17"
			xmlns="http://www.w3.org/2000/svg"
			fill={fill || theme.colors.white}
			stroke={stroke || theme.colors.grey.dark10}
			{...rest}
		>
			<path
				d="M11.3125 6.62494L7.11747 10.3749L5.6875 9.09667M16 3.81244L16 13.1875C16 14.7408 14.7408 16 13.1875 16H3.8125C2.2592 16 1 14.7408 1 13.1875V3.81244C1 2.25914 2.2592 0.999939 3.8125 0.999939H13.1875C14.7408 0.999939 16 2.25914 16 3.81244Z"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg.SVG>
	)
}

export const back = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="14" height="14" viewBox="0 0 14 14" fill="none" {...rest}>
			<path
				d="M6.17393 9.97178C6.35071 10.1839 6.66599 10.2126 6.87813 10.0358C7.09027 9.85902 7.11893 9.54373 6.94215 9.3316L6.17393 9.97178ZM4.34831 7.00002L3.9642 6.67993C3.80968 6.86535 3.80968 7.13469 3.9642 7.32011L4.34831 7.00002ZM6.94215 4.66844C7.11893 4.4563 7.09027 4.14102 6.87813 3.96424C6.66599 3.78746 6.35071 3.81612 6.17393 4.02826L6.94215 4.66844ZM9.65165 7.50002C9.92779 7.50002 10.1517 7.27616 10.1517 7.00002C10.1517 6.72388 9.92779 6.50002 9.65165 6.50002V7.50002ZM6.94215 9.3316L4.73242 6.67993L3.9642 7.32011L6.17393 9.97178L6.94215 9.3316ZM4.73242 7.32011L6.94215 4.66844L6.17393 4.02826L3.9642 6.67993L4.73242 7.32011ZM4.34831 7.50002H9.65165V6.50002H4.34831V7.50002ZM3.11091 3.11091C5.2588 0.963029 8.7412 0.963029 10.8891 3.11091L11.5962 2.40381C9.05779 -0.134602 4.94221 -0.134602 2.40381 2.40381L3.11091 3.11091ZM10.8891 3.11091C13.037 5.2588 13.037 8.7412 10.8891 10.8891L11.5962 11.5962C14.1346 9.05779 14.1346 4.94221 11.5962 2.40381L10.8891 3.11091ZM10.8891 10.8891C8.7412 13.037 5.2588 13.037 3.11091 10.8891L2.40381 11.5962C4.94221 14.1346 9.05779 14.1346 11.5962 11.5962L10.8891 10.8891ZM3.11091 10.8891C0.963029 8.7412 0.963029 5.2588 3.11091 3.11091L2.40381 2.40381C-0.134602 4.94221 -0.134602 9.05779 2.40381 11.5962L3.11091 10.8891Z"
				fill={theme.colors.blue.blue}
			/>
		</svg.SVG>
	)
}

export const accepted = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M9.09467 5.65533L6.25 8.5L5.28033 7.53033M7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1Z"
				stroke={theme.colors.blue.blue}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

export const review = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="15" height="11" viewBox="0 0 15 11" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M14,5.6c0,0-2.9,4-6.5,4S1,5.6,1,5.6s2.9-4,6.5-4S14,5.6,14,5.6z"
				fill="none"
				stroke={theme.colors.blue.blue}
				strokeWidth="1.0124"
			/>
			<circle cx="7.5" cy="5.6" r="1.3" fill="none" stroke={theme.colors.blue.blue} />
		</svg.SVG>
	)
}

export const rejected = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<g id="Group 189">
				<path
					id="Icon"
					d="M7.62132 4.58579C7.81658 4.39052 7.81658 4.07394 7.62132 3.87868C7.42606 3.68342 7.10948 3.68342 6.91421 3.87868L7.62132 4.58579ZM3.37868 7.41421C3.18342 7.60948 3.18342 7.92606 3.37868 8.12132C3.57394 8.31658 3.89052 8.31658 4.08579 8.12132L3.37868 7.41421ZM6.91421 8.12132C7.10948 8.31658 7.42606 8.31658 7.62132 8.12132C7.81658 7.92606 7.81658 7.60948 7.62132 7.41421L6.91421 8.12132ZM4.08579 3.87868C3.89052 3.68342 3.57394 3.68342 3.37868 3.87868C3.18342 4.07394 3.18342 4.39052 3.37868 4.58579L4.08579 3.87868ZM10 6C10 8.48528 7.98528 10.5 5.5 10.5V11.5C8.53757 11.5 11 9.03757 11 6H10ZM5.5 10.5C3.01472 10.5 1 8.48528 1 6H0C0 9.03757 2.46243 11.5 5.5 11.5V10.5ZM1 6C1 3.51472 3.01472 1.5 5.5 1.5V0.5C2.46243 0.5 0 2.96243 0 6H1ZM5.5 1.5C7.98528 1.5 10 3.51472 10 6H11C11 2.96243 8.53757 0.5 5.5 0.5V1.5ZM6.91421 3.87868L5.14645 5.64645L5.85355 6.35355L7.62132 4.58579L6.91421 3.87868ZM5.14645 5.64645L3.37868 7.41421L4.08579 8.12132L5.85355 6.35355L5.14645 5.64645ZM7.62132 7.41421L5.85355 5.64645L5.14645 6.35355L6.91421 8.12132L7.62132 7.41421ZM5.85355 5.64645L4.08579 3.87868L3.37868 4.58579L5.14645 6.35355L5.85355 5.64645Z"
					fill={theme.colors.white}
				/>
			</g>
		</svg.SVG>
	)
}

export const backarrow = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<g id="Back Arrow">
				<rect id="Back Arrow Box" width="36" height="36" fill="none" />
				<path
					id="Icon"
					d="M15.314 10L10 15.314M10 15.314L15.314 20.628M10 15.314L22.8 15.314C25.0091 15.314 26.8 17.1049 26.8 19.314V25.6"
					stroke="white"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
		</svg.SVG>
	)
}

export const poligon = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="41" height="28" viewBox="0 0 41 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<g filter="url(#filter0_d_1222_5935)">
				<path d="M20.5 20L4.47853 0.500001L36.5215 0.500004L20.5 20Z" fill={theme.colors.grey.dark50} />
			</g>
			<defs>
				<filter
					id="filter0_d_1222_5935"
					x="0.478531"
					y="0.5"
					width="40.0429"
					height="27.5"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1222_5935" />
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1222_5935" result="shape" />
				</filter>
			</defs>
		</svg.SVG>
	)
}

interface clicableIconProps extends svg.SVGProps, containers.CursorProps {
	onClick?: React.MouseEventHandler<SVGSVGElement>
}

interface checkboxIconProps extends clicableIconProps {
	checked?: boolean
}

export const onbrand = (props: clicableIconProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="103" height="39" viewBox="0 0 103 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<g filter="url(#filter0_i_1319_8577)">
				<rect width="103" height="38.277" rx="19.1385" fill={theme.colors.blue.blue} />
			</g>
			<rect
				x="0.5"
				y="0.5"
				width="102"
				height="37.277"
				rx="18.6385"
				stroke={theme.colors.grey.dark50}
				strokeOpacity="0.2"
			/>
			<g filter="url(#filter1_i_1319_8577)">
				<circle cx="19.7417" cy="18.8835" r="17.1667" fill={theme.colors.blue.blue} />
			</g>
			<path
				d="M22.7382 16.9595L18.6687 21.029L17.2816 19.6418M19.7417 10.2998C15.0012 10.2998 11.1583 14.1427 11.1583 18.8831C11.1583 23.6236 15.0012 27.4665 19.7417 27.4665C24.4821 27.4665 28.325 23.6236 28.325 18.8831C28.325 14.1427 24.4821 10.2998 19.7417 10.2998Z"
				stroke={theme.colors.white}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M49.5855 19.3429V19.6899C49.5855 20.2465 49.5101 20.746 49.3592 21.1886C49.2083 21.6312 48.9954 22.0084 48.7205 22.3202C48.4455 22.6287 48.117 22.8651 47.7347 23.0293C47.3559 23.1936 46.9351 23.2758 46.4724 23.2758C46.013 23.2758 45.5922 23.1936 45.21 23.0293C44.8311 22.8651 44.5026 22.6287 44.2243 22.3202C43.946 22.0084 43.7297 21.6312 43.5755 21.1886C43.4246 20.746 43.3492 20.2465 43.3492 19.6899V19.3429C43.3492 18.7829 43.4246 18.2834 43.5755 17.8441C43.7264 17.4016 43.9393 17.0244 44.2142 16.7125C44.4925 16.4007 44.8211 16.1627 45.2 15.9984C45.5822 15.8341 46.003 15.752 46.4623 15.752C46.925 15.752 47.3458 15.8341 47.7247 15.9984C48.1069 16.1627 48.4355 16.4007 48.7104 16.7125C48.9887 17.0244 49.2033 17.4016 49.3542 17.8441C49.5084 18.2834 49.5855 18.7829 49.5855 19.3429ZM48.0616 19.6899V19.3328C48.0616 18.9439 48.0264 18.6019 47.956 18.3068C47.8856 18.0118 47.7817 17.7637 47.6442 17.5625C47.5067 17.3613 47.3391 17.2104 47.1413 17.1099C46.9435 17.0059 46.7171 16.954 46.4623 16.954C46.2075 16.954 45.9812 17.0059 45.7834 17.1099C45.5889 17.2104 45.4229 17.3613 45.2855 17.5625C45.1513 17.7637 45.0491 18.0118 44.9787 18.3068C44.9083 18.6019 44.8731 18.9439 44.8731 19.3328V19.6899C44.8731 20.0755 44.9083 20.4175 44.9787 20.7159C45.0491 21.0109 45.153 21.2607 45.2905 21.4652C45.428 21.6664 45.5956 21.819 45.7934 21.9229C45.9912 22.0268 46.2176 22.0788 46.4724 22.0788C46.7272 22.0788 46.9535 22.0268 47.1513 21.9229C47.3491 21.819 47.5151 21.6664 47.6492 21.4652C47.7833 21.2607 47.8856 21.0109 47.956 20.7159C48.0264 20.4175 48.0616 20.0755 48.0616 19.6899Z"
				fill={theme.colors.white}
			/>
			<path
				d="M51.9996 18.8953V23.1752H50.5511V17.7335H51.909L51.9996 18.8953ZM51.7883 20.2632H51.3961C51.3961 19.8609 51.448 19.4988 51.552 19.1769C51.6559 18.8517 51.8018 18.5751 51.9895 18.3471C52.1773 18.1157 52.4002 17.9397 52.6584 17.819C52.9199 17.6949 53.2116 17.6329 53.5335 17.6329C53.7883 17.6329 54.0213 17.6698 54.2326 17.7436C54.4438 17.8173 54.6249 17.9347 54.7757 18.0956C54.93 18.2565 55.0473 18.4694 55.1278 18.7343C55.2116 18.9992 55.2535 19.3228 55.2535 19.705V23.1752H53.795V19.7C53.795 19.4585 53.7615 19.2708 53.6944 19.1367C53.6274 19.0026 53.5285 18.9087 53.3977 18.855C53.2703 18.798 53.1127 18.7695 52.925 18.7695C52.7305 18.7695 52.5612 18.8081 52.417 18.8852C52.2762 18.9623 52.1588 19.0696 52.065 19.2071C51.9744 19.3412 51.9057 19.4988 51.8588 19.6798C51.8118 19.8609 51.7883 20.0554 51.7883 20.2632Z"
				fill={theme.colors.white}
			/>
			<path d="M59.2116 19.4636V20.6002H56.37V19.4636H59.2116Z" fill={theme.colors.white} />
			<path
				d="M63.3758 19.9615H61.4949L61.4848 18.9254H63.064C63.3423 18.9254 63.5703 18.8902 63.748 18.8198C63.9257 18.7461 64.0582 18.6404 64.1453 18.503C64.2359 18.3622 64.2811 18.1912 64.2811 17.99C64.2811 17.762 64.2375 17.5776 64.1504 17.4368C64.0665 17.2959 63.9341 17.1937 63.753 17.13C63.5753 17.0663 63.3457 17.0344 63.064 17.0344H62.0179V23.1752H60.5091V15.8525H63.064C63.4898 15.8525 63.8704 15.8928 64.2057 15.9732C64.5443 16.0537 64.831 16.1761 65.0657 16.3404C65.3004 16.5047 65.4798 16.7125 65.6038 16.964C65.7279 17.2121 65.7899 17.5072 65.7899 17.8492C65.7899 18.1509 65.7212 18.4292 65.5837 18.684C65.4496 18.9389 65.2367 19.1467 64.945 19.3077C64.6566 19.4686 64.2794 19.5575 63.8134 19.5742L63.3758 19.9615ZM63.3105 23.1752H61.0825L61.6709 21.9983H63.3105C63.5753 21.9983 63.7916 21.9564 63.9592 21.8726C64.1269 21.7854 64.2509 21.6681 64.3314 21.5206C64.4119 21.373 64.4521 21.2037 64.4521 21.0126C64.4521 20.798 64.4152 20.6119 64.3415 20.4543C64.2711 20.2968 64.1571 20.1761 63.9995 20.0922C63.8419 20.0051 63.634 19.9615 63.3758 19.9615H61.9224L61.9324 18.9254H63.743L64.09 19.3328C64.5359 19.3261 64.8947 19.4049 65.1663 19.5692C65.4412 19.7301 65.6407 19.9397 65.7648 20.1979C65.8922 20.456 65.9559 20.7326 65.9559 21.0277C65.9559 21.4971 65.8536 21.8927 65.6491 22.2146C65.4446 22.5331 65.1445 22.7729 64.7488 22.9338C64.3566 23.0947 63.8771 23.1752 63.3105 23.1752Z"
				fill={theme.colors.white}
			/>
			<path
				d="M68.4454 18.9204V23.1752H66.9969V17.7335H68.3599L68.4454 18.9204ZM70.0849 17.6983L70.0598 19.0411C69.9894 19.0311 69.9039 19.0227 69.8033 19.016C69.7061 19.0059 69.6172 19.0009 69.5367 19.0009C69.3322 19.0009 69.1545 19.0277 69.0036 19.0813C68.8561 19.1316 68.732 19.2071 68.6315 19.3077C68.5342 19.4083 68.4605 19.5306 68.4102 19.6748C68.3632 19.819 68.3364 19.9833 68.3297 20.1677L68.038 20.0771C68.038 19.7251 68.0732 19.4015 68.1436 19.1065C68.214 18.8081 68.3163 18.5482 68.4504 18.327C68.5879 18.1057 68.7555 17.9347 68.9533 17.814C69.1512 17.6933 69.3775 17.6329 69.6323 17.6329C69.7128 17.6329 69.7949 17.6396 69.8787 17.653C69.9625 17.6631 70.0313 17.6782 70.0849 17.6983Z"
				fill={theme.colors.white}
			/>
			<path
				d="M73.535 21.948V19.5239C73.535 19.3496 73.5065 19.2004 73.4495 19.0763C73.3925 18.9489 73.3037 18.85 73.183 18.7796C73.0656 18.7092 72.9131 18.674 72.7253 18.674C72.5644 18.674 72.4252 18.7025 72.3079 18.7595C72.1905 18.8131 72.1 18.8919 72.0363 18.9958C71.9726 19.0964 71.9407 19.2155 71.9407 19.3529H70.4923C70.4923 19.1216 70.5459 18.902 70.6532 18.6941C70.7605 18.4862 70.9164 18.3035 71.121 18.1459C71.3255 17.985 71.5686 17.8592 71.8502 17.7687C72.1352 17.6782 72.4537 17.6329 72.8058 17.6329C73.2282 17.6329 73.6038 17.7033 73.9323 17.8441C74.2609 17.985 74.5191 18.1962 74.7068 18.4778C74.898 18.7595 74.9935 19.1115 74.9935 19.534V21.8625C74.9935 22.161 75.012 22.4057 75.0488 22.5968C75.0857 22.7846 75.1394 22.9489 75.2098 23.0897V23.1752H73.7463C73.6758 23.0277 73.6222 22.8433 73.5853 22.622C73.5518 22.3973 73.535 22.1727 73.535 21.948ZM73.7261 19.8609L73.7362 20.6807H72.9265C72.7354 20.6807 72.5694 20.7025 72.4286 20.746C72.2878 20.7896 72.1721 20.8517 72.0816 20.9321C71.991 21.0092 71.924 21.0998 71.8804 21.2037C71.8401 21.3076 71.82 21.4216 71.82 21.5457C71.82 21.6698 71.8485 21.7821 71.9055 21.8827C71.9625 21.9799 72.0447 22.057 72.152 22.114C72.2593 22.1677 72.385 22.1945 72.5292 22.1945C72.7471 22.1945 72.9365 22.1509 73.0975 22.0637C73.2584 21.9765 73.3825 21.8693 73.4696 21.7418C73.5602 21.6144 73.6071 21.4937 73.6105 21.3797L73.9927 21.9933C73.939 22.1308 73.8653 22.2733 73.7714 22.4208C73.6809 22.5683 73.5652 22.7075 73.4244 22.8382C73.2836 22.9656 73.1142 23.0713 72.9164 23.1551C72.7186 23.2355 72.4839 23.2758 72.2123 23.2758C71.867 23.2758 71.5535 23.207 71.2718 23.0696C70.9936 22.9288 70.7723 22.736 70.608 22.4912C70.447 22.2431 70.3666 21.9615 70.3666 21.6463C70.3666 21.3613 70.4202 21.1082 70.5275 20.8869C70.6348 20.6656 70.7924 20.4795 71.0003 20.3286C71.2115 20.1744 71.4747 20.0587 71.7899 19.9816C72.105 19.9011 72.4705 19.8609 72.8862 19.8609H73.7261Z"
				fill={theme.colors.white}
			/>
			<path
				d="M77.5283 18.8953V23.1752H76.0798V17.7335H77.4378L77.5283 18.8953ZM77.3171 20.2632H76.9248C76.9248 19.8609 76.9767 19.4988 77.0807 19.1769C77.1846 18.8517 77.3305 18.5751 77.5182 18.3471C77.706 18.1157 77.929 17.9397 78.1871 17.819C78.4486 17.6949 78.7403 17.6329 79.0622 17.6329C79.317 17.6329 79.5501 17.6698 79.7613 17.7436C79.9725 17.8173 80.1536 17.9347 80.3045 18.0956C80.4587 18.2565 80.576 18.4694 80.6565 18.7343C80.7403 18.9992 80.7822 19.3228 80.7822 19.705V23.1752H79.3237V19.7C79.3237 19.4585 79.2902 19.2708 79.2232 19.1367C79.1561 19.0026 79.0572 18.9087 78.9264 18.855C78.799 18.798 78.6414 18.7695 78.4537 18.7695C78.2592 18.7695 78.0899 18.8081 77.9457 18.8852C77.8049 18.9623 77.6875 19.0696 77.5937 19.2071C77.5031 19.3412 77.4344 19.4988 77.3875 19.6798C77.3405 19.8609 77.3171 20.0554 77.3171 20.2632Z"
				fill={theme.colors.white}
			/>
			<path
				d="M85.0974 21.9883V15.4502H86.5559V23.1752H85.2432L85.0974 21.9883ZM81.6573 20.5197V20.4141C81.6573 19.9984 81.7043 19.6212 81.7982 19.2825C81.892 18.9405 82.0295 18.6472 82.2106 18.4024C82.3916 18.1576 82.6146 17.9682 82.8795 17.8341C83.1443 17.7 83.4461 17.6329 83.7847 17.6329C84.1033 17.6329 84.3815 17.7 84.6196 17.8341C84.861 17.9682 85.0655 18.1593 85.2332 18.4074C85.4042 18.6522 85.5416 18.9422 85.6456 19.2775C85.7495 19.6094 85.8249 19.9732 85.8719 20.3688V20.6002C85.8249 20.9791 85.7495 21.3311 85.6456 21.6563C85.5416 21.9816 85.4042 22.2666 85.2332 22.5113C85.0655 22.7527 84.861 22.9405 84.6196 23.0746C84.3782 23.2087 84.0965 23.2758 83.7747 23.2758C83.436 23.2758 83.1343 23.207 82.8694 23.0696C82.6079 22.9321 82.3866 22.7393 82.2055 22.4912C82.0278 22.2431 81.892 21.9514 81.7982 21.6161C81.7043 21.2808 81.6573 20.9154 81.6573 20.5197ZM83.1058 20.4141V20.5197C83.1058 20.7444 83.1225 20.9539 83.1561 21.1484C83.1929 21.3429 83.2516 21.5155 83.3321 21.6664C83.4159 21.8139 83.5232 21.9296 83.654 22.0134C83.7881 22.0939 83.9507 22.1341 84.1418 22.1341C84.3899 22.1341 84.5944 22.0788 84.7554 21.9682C84.9163 21.8542 85.0387 21.6983 85.1225 21.5004C85.2097 21.3026 85.26 21.0746 85.2734 20.8165V20.1576C85.2633 19.9464 85.2332 19.7569 85.1829 19.5893C85.1359 19.4183 85.0655 19.2725 84.9716 19.1518C84.8811 19.0311 84.7671 18.9372 84.6297 18.8701C84.4955 18.8031 84.3363 18.7695 84.1519 18.7695C83.9641 18.7695 83.8032 18.8131 83.6691 18.9003C83.5349 18.9841 83.426 19.0998 83.3422 19.2473C83.2617 19.3948 83.2013 19.5692 83.1611 19.7704C83.1242 19.9682 83.1058 20.1828 83.1058 20.4141Z"
				fill={theme.colors.white}
			/>
			<defs>
				<filter
					id="filter0_i_1319_8577"
					x="0"
					y="0"
					width="103"
					height="40.2773"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology radius="4" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_1319_8577" />
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="3" />
					<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.320651 0 0 0 0 0.275129 0 0 0 0 0.600282 0 0 0 0.21 0" />
					<feBlend mode="normal" in2="shape" result="effect1_innerShadow_1319_8577" />
				</filter>
				<filter
					id="filter1_i_1319_8577"
					x="2.57501"
					y="-2.2832"
					width="34.3333"
					height="38.333"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="-4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.0478622 0 0 0 0 0.371589 0 0 0 0 1 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="shape" result="effect1_innerShadow_1319_8577" />
				</filter>
			</defs>
		</svg.SVG>
	)
}

export const offbrand = (props: clicableIconProps) => {
	let { ...rest } = props
	return (
		<svg.SVG width="103" height="39" viewBox="0 0 103 39" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<g filter="url(#filter0_i_1319_8572)">
				<rect width="103" height="38.277" rx="19.1385" fill={theme.colors.red.cinnabar} />
			</g>
			<rect
				x="0.5"
				y="0.5"
				width="102"
				height="37.277"
				rx="18.6385"
				stroke={theme.colors.grey.dark50}
				strokeOpacity="0.2"
			/>
			<ellipse cx="83.2583" cy="18.8835" rx="17.1667" ry="17.1667" fill={theme.colors.red.cinnabar} />
			<path
				d="M19.5438 19.343V19.69C19.5438 20.2466 19.4684 20.7462 19.3175 21.1888C19.1666 21.6313 18.9537 22.0085 18.6788 22.3204C18.4038 22.6288 18.0753 22.8652 17.693 23.0295C17.3142 23.1938 16.8934 23.2759 16.4307 23.2759C15.9713 23.2759 15.5506 23.1938 15.1683 23.0295C14.7895 22.8652 14.4609 22.6288 14.1826 22.3204C13.9043 22.0085 13.688 21.6313 13.5338 21.1888C13.3829 20.7462 13.3075 20.2466 13.3075 19.69V19.343C13.3075 18.7831 13.3829 18.2835 13.5338 17.8443C13.6847 17.4017 13.8976 17.0245 14.1725 16.7127C14.4508 16.4009 14.7794 16.1628 15.1583 15.9985C15.5405 15.8342 15.9613 15.7521 16.4206 15.7521C16.8833 15.7521 17.3041 15.8342 17.683 15.9985C18.0652 16.1628 18.3938 16.4009 18.6687 16.7127C18.947 17.0245 19.1616 17.4017 19.3125 17.8443C19.4667 18.2835 19.5438 18.7831 19.5438 19.343ZM18.0199 19.69V19.333C18.0199 18.944 17.9847 18.602 17.9143 18.307C17.8439 18.0119 17.74 17.7638 17.6025 17.5626C17.465 17.3615 17.2974 17.2106 17.0996 17.11C16.9018 17.0061 16.6754 16.9541 16.4206 16.9541C16.1658 16.9541 15.9395 17.0061 15.7417 17.11C15.5472 17.2106 15.3812 17.3615 15.2438 17.5626C15.1097 17.7638 15.0074 18.0119 14.937 18.307C14.8666 18.602 14.8314 18.944 14.8314 19.333V19.69C14.8314 20.0756 14.8666 20.4176 14.937 20.716C15.0074 21.0111 15.1113 21.2609 15.2488 21.4654C15.3863 21.6666 15.5539 21.8191 15.7517 21.923C15.9496 22.027 16.1759 22.079 16.4307 22.079C16.6855 22.079 16.9118 22.027 17.1096 21.923C17.3075 21.8191 17.4734 21.6666 17.6075 21.4654C17.7417 21.2609 17.8439 21.0111 17.9143 20.716C17.9847 20.4176 18.0199 20.0756 18.0199 19.69Z"
				fill={theme.colors.white}
			/>
			<path
				d="M22.3854 23.1753H20.9269V17.2508C20.9269 16.8384 21.0073 16.4914 21.1683 16.2098C21.3326 15.9248 21.5622 15.7102 21.8573 15.566C22.1557 15.4185 22.5094 15.3447 22.9185 15.3447C23.0526 15.3447 23.1817 15.3548 23.3057 15.3749C23.4298 15.3917 23.5505 15.4135 23.6678 15.4403L23.6528 16.5316C23.5891 16.5149 23.522 16.5031 23.4516 16.4964C23.3812 16.4897 23.299 16.4864 23.2052 16.4864C23.0308 16.4864 22.8816 16.5166 22.7575 16.5769C22.6368 16.6339 22.5446 16.7194 22.4809 16.8334C22.4172 16.9474 22.3854 17.0865 22.3854 17.2508V23.1753ZM23.4717 17.7336V18.7596H20.1172V17.7336H23.4717Z"
				fill={theme.colors.white}
			/>
			<path
				d="M26.0769 23.1753H24.6184V17.2508C24.6184 16.8384 24.6989 16.4914 24.8598 16.2098C25.0241 15.9248 25.2538 15.7102 25.5488 15.566C25.8472 15.4185 26.2009 15.3447 26.61 15.3447C26.7441 15.3447 26.8732 15.3548 26.9972 15.3749C27.1213 15.3917 27.242 15.4135 27.3594 15.4403L27.3443 16.5316C27.2806 16.5149 27.2135 16.5031 27.1431 16.4964C27.0727 16.4897 26.9905 16.4864 26.8967 16.4864C26.7223 16.4864 26.5731 16.5166 26.449 16.5769C26.3283 16.6339 26.2361 16.7194 26.1724 16.8334C26.1087 16.9474 26.0769 17.0865 26.0769 17.2508V23.1753ZM27.1632 17.7336V18.7596H23.8087V17.7336H27.1632Z"
				fill={theme.colors.white}
			/>
			<path d="M30.7793 19.4637V20.6003H27.9377V19.4637H30.7793Z" fill={theme.colors.white} />
			<path
				d="M34.9435 19.9616H33.0626L33.0525 18.9256H34.6317C34.91 18.9256 35.138 18.8904 35.3157 18.82C35.4934 18.7462 35.6258 18.6406 35.713 18.5031C35.8035 18.3623 35.8488 18.1913 35.8488 17.9901C35.8488 17.7621 35.8052 17.5777 35.718 17.4369C35.6342 17.2961 35.5018 17.1938 35.3207 17.1301C35.143 17.0664 34.9134 17.0346 34.6317 17.0346H33.5856V23.1753H32.0768V15.8527H34.6317C35.0575 15.8527 35.4381 15.8929 35.7734 15.9734C36.112 16.0539 36.3987 16.1762 36.6334 16.3405C36.8681 16.5048 37.0475 16.7127 37.1715 16.9642C37.2956 17.2123 37.3576 17.5073 37.3576 17.8493C37.3576 18.1511 37.2889 18.4294 37.1514 18.6842C37.0173 18.939 36.8044 19.1469 36.5127 19.3078C36.2243 19.4687 35.8471 19.5576 35.3811 19.5744L34.9435 19.9616ZM34.8781 23.1753H32.6502L33.2386 21.9985H34.8781C35.143 21.9985 35.3593 21.9566 35.5269 21.8728C35.6946 21.7856 35.8186 21.6682 35.8991 21.5207C35.9796 21.3732 36.0198 21.2039 36.0198 21.0127C36.0198 20.7982 35.9829 20.6121 35.9092 20.4545C35.8387 20.2969 35.7247 20.1762 35.5672 20.0924C35.4096 20.0052 35.2017 19.9616 34.9435 19.9616H33.4901L33.5001 18.9256H35.3107L35.6577 19.333C36.1036 19.3263 36.4624 19.405 36.734 19.5693C37.0089 19.7303 37.2084 19.9398 37.3324 20.198C37.4599 20.4562 37.5236 20.7328 37.5236 21.0278C37.5236 21.4972 37.4213 21.8929 37.2168 22.2147C37.0122 22.5333 36.7122 22.773 36.3165 22.9339C35.9242 23.0949 35.4448 23.1753 34.8781 23.1753Z"
				fill={theme.colors.white}
			/>
			<path
				d="M40.0131 18.9206V23.1753H38.5646V17.7336H39.9276L40.0131 18.9206ZM41.6526 17.6984L41.6275 19.0413C41.5571 19.0312 41.4716 19.0228 41.371 19.0161C41.2737 19.0061 41.1849 19.001 41.1044 19.001C40.8999 19.001 40.7222 19.0278 40.5713 19.0815C40.4238 19.1318 40.2997 19.2072 40.1991 19.3078C40.1019 19.4084 40.0281 19.5308 39.9779 19.675C39.9309 19.8191 39.9041 19.9834 39.8974 20.1678L39.6057 20.0773C39.6057 19.7252 39.6409 19.4017 39.7113 19.1066C39.7817 18.8082 39.884 18.5484 40.0181 18.3271C40.1556 18.1058 40.3232 17.9348 40.521 17.8141C40.7188 17.6934 40.9452 17.6331 41.2 17.6331C41.2804 17.6331 41.3626 17.6398 41.4464 17.6532C41.5302 17.6632 41.599 17.6783 41.6526 17.6984Z"
				fill={theme.colors.white}
			/>
			<path
				d="M45.1027 21.9482V19.5241C45.1027 19.3497 45.0742 19.2005 45.0172 19.0765C44.9602 18.9491 44.8714 18.8501 44.7507 18.7797C44.6333 18.7093 44.4808 18.6741 44.293 18.6741C44.1321 18.6741 43.9929 18.7026 43.8756 18.7596C43.7582 18.8133 43.6677 18.8921 43.604 18.996C43.5403 19.0966 43.5084 19.2156 43.5084 19.3531H42.06C42.06 19.1217 42.1136 18.9021 42.2209 18.6942C42.3282 18.4864 42.4841 18.3036 42.6886 18.146C42.8932 17.9851 43.1363 17.8594 43.4179 17.7688C43.7029 17.6783 44.0214 17.6331 44.3735 17.6331C44.7959 17.6331 45.1714 17.7035 45.5 17.8443C45.8286 17.9851 46.0868 18.1963 46.2745 18.478C46.4656 18.7596 46.5612 19.1117 46.5612 19.5341V21.8627C46.5612 22.1611 46.5796 22.4059 46.6165 22.597C46.6534 22.7847 46.7071 22.949 46.7775 23.0898V23.1753H45.3139C45.2435 23.0278 45.1899 22.8434 45.153 22.6221C45.1195 22.3975 45.1027 22.1728 45.1027 21.9482ZM45.2938 19.861L45.3039 20.6808H44.4942C44.3031 20.6808 44.1371 20.7026 43.9963 20.7462C43.8554 20.7898 43.7398 20.8518 43.6492 20.9323C43.5587 21.0094 43.4917 21.0999 43.4481 21.2039C43.4078 21.3078 43.3877 21.4218 43.3877 21.5458C43.3877 21.6699 43.4162 21.7822 43.4732 21.8828C43.5302 21.98 43.6124 22.0572 43.7197 22.1142C43.8269 22.1678 43.9527 22.1946 44.0968 22.1946C44.3148 22.1946 44.5042 22.151 44.6652 22.0639C44.8261 21.9767 44.9502 21.8694 45.0373 21.742C45.1279 21.6146 45.1748 21.4939 45.1781 21.3799L45.5604 21.9935C45.5067 22.1309 45.433 22.2734 45.3391 22.4209C45.2486 22.5685 45.1329 22.7076 44.9921 22.8384C44.8512 22.9658 44.6819 23.0714 44.4841 23.1552C44.2863 23.2357 44.0516 23.2759 43.78 23.2759C43.4347 23.2759 43.1212 23.2072 42.8395 23.0697C42.5612 22.9289 42.3399 22.7361 42.1757 22.4914C42.0147 22.2432 41.9343 21.9616 41.9343 21.6464C41.9343 21.3614 41.9879 21.1083 42.0952 20.887C42.2025 20.6657 42.3601 20.4796 42.5679 20.3288C42.7792 20.1745 43.0424 20.0589 43.3575 19.9817C43.6727 19.9013 44.0382 19.861 44.4539 19.861H45.2938Z"
				fill={theme.colors.white}
			/>
			<path
				d="M49.096 18.8954V23.1753H47.6475V17.7336H49.0054L49.096 18.8954ZM48.8847 20.2634H48.4925C48.4925 19.861 48.5444 19.4989 48.6484 19.1771C48.7523 18.8518 48.8982 18.5752 49.0859 18.3472C49.2737 18.1159 49.4966 17.9398 49.7548 17.8191C50.0163 17.6951 50.308 17.6331 50.6299 17.6331C50.8847 17.6331 51.1177 17.6699 51.329 17.7437C51.5402 17.8175 51.7213 17.9348 51.8721 18.0958C52.0264 18.2567 52.1437 18.4696 52.2242 18.7345C52.308 18.9993 52.3499 19.3229 52.3499 19.7051V23.1753H50.8914V19.7001C50.8914 19.4587 50.8579 19.2709 50.7908 19.1368C50.7238 19.0027 50.6249 18.9088 50.4941 18.8552C50.3667 18.7982 50.2091 18.7697 50.0214 18.7697C49.8269 18.7697 49.6576 18.8082 49.5134 18.8854C49.3726 18.9625 49.2552 19.0698 49.1614 19.2072C49.0708 19.3413 49.0021 19.4989 48.9552 19.68C48.9082 19.861 48.8847 20.0555 48.8847 20.2634Z"
				fill={theme.colors.white}
			/>
			<path
				d="M56.6651 21.9884V15.4503H58.1236V23.1753H56.8109L56.6651 21.9884ZM53.225 20.5199V20.4143C53.225 19.9985 53.272 19.6213 53.3658 19.2827C53.4597 18.9407 53.5972 18.6473 53.7782 18.4025C53.9593 18.1578 54.1823 17.9683 54.4471 17.8342C54.712 17.7001 55.0138 17.6331 55.3524 17.6331C55.6709 17.6331 55.9492 17.7001 56.1873 17.8342C56.4287 17.9683 56.6332 18.1595 56.8009 18.4076C56.9718 18.6523 57.1093 18.9423 57.2133 19.2776C57.3172 19.6096 57.3926 19.9734 57.4396 20.369V20.6003C57.3926 20.9792 57.3172 21.3313 57.2133 21.6565C57.1093 21.9817 56.9718 22.2667 56.8009 22.5115C56.6332 22.7529 56.4287 22.9406 56.1873 23.0748C55.9459 23.2089 55.6642 23.2759 55.3424 23.2759C55.0037 23.2759 54.702 23.2072 54.4371 23.0697C54.1756 22.9323 53.9543 22.7395 53.7732 22.4914C53.5955 22.2432 53.4597 21.9515 53.3658 21.6163C53.272 21.281 53.225 20.9155 53.225 20.5199ZM54.6735 20.4143V20.5199C54.6735 20.7445 54.6902 20.9541 54.7238 21.1485C54.7606 21.343 54.8193 21.5157 54.8998 21.6666C54.9836 21.8141 55.0909 21.9298 55.2217 22.0136C55.3558 22.094 55.5184 22.1343 55.7095 22.1343C55.9576 22.1343 56.1621 22.079 56.3231 21.9683C56.484 21.8543 56.6064 21.6984 56.6902 21.5006C56.7774 21.3028 56.8277 21.0748 56.8411 20.8166V20.1578C56.831 19.9465 56.8009 19.7571 56.7506 19.5895C56.7036 19.4185 56.6332 19.2726 56.5393 19.1519C56.4488 19.0312 56.3348 18.9373 56.1973 18.8703C56.0632 18.8032 55.904 18.7697 55.7196 18.7697C55.5318 18.7697 55.3709 18.8133 55.2367 18.9004C55.1026 18.9843 54.9937 19.0999 54.9098 19.2475C54.8294 19.395 54.769 19.5693 54.7288 19.7705C54.6919 19.9683 54.6735 20.1829 54.6735 20.4143Z"
				fill={theme.colors.white}
			/>
			<path
				d="M87.0001 16.5556C87.3906 16.1651 87.3906 15.5319 87.0001 15.1414C86.6096 14.7508 85.9764 14.7508 85.5859 15.1414L87.0001 16.5556ZM79.5165 21.2107C79.126 21.6012 79.126 22.2344 79.5165 22.6249C79.9071 23.0154 80.5402 23.0154 80.9308 22.6249L79.5165 21.2107ZM85.5859 22.6249C85.9764 23.0154 86.6096 23.0154 87.0001 22.6249C87.3906 22.2344 87.3906 21.6012 87.0001 21.2107L85.5859 22.6249ZM80.9308 15.1414C80.5402 14.7508 79.9071 14.7508 79.5165 15.1414C79.126 15.5319 79.126 16.1651 79.5165 16.5556L80.9308 15.1414ZM90.8417 18.8831C90.8417 23.0713 87.4465 26.4665 83.2583 26.4665V28.4665C88.551 28.4665 92.8417 24.1759 92.8417 18.8831H90.8417ZM83.2583 26.4665C79.0702 26.4665 75.675 23.0713 75.675 18.8831H73.675C73.675 24.1759 77.9656 28.4665 83.2583 28.4665V26.4665ZM75.675 18.8831C75.675 14.695 79.0702 11.2998 83.2583 11.2998V9.2998C77.9656 9.2998 73.675 13.5904 73.675 18.8831H75.675ZM83.2583 11.2998C87.4465 11.2998 90.8417 14.695 90.8417 18.8831H92.8417C92.8417 13.5904 88.551 9.2998 83.2583 9.2998V11.2998ZM85.5859 15.1414L82.5512 18.176L83.9654 19.5902L87.0001 16.5556L85.5859 15.1414ZM82.5512 18.176L79.5165 21.2107L80.9308 22.6249L83.9654 19.5902L82.5512 18.176ZM87.0001 21.2107L83.9654 18.176L82.5512 19.5902L85.5859 22.6249L87.0001 21.2107ZM83.9654 18.176L80.9308 15.1414L79.5165 16.5556L82.5512 19.5902L83.9654 18.176Z"
				fill={theme.colors.white}
			/>
			<defs>
				<filter
					id="filter0_i_1319_8572"
					x="0"
					y="0"
					width="103"
					height="40.2773"
					filterUnits="userSpaceOnUse"
					colorInterpolationFilters="sRGB"
				>
					<feFlood floodOpacity="0" result="BackgroundImageFix" />
					<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feMorphology radius="4" operator="dilate" in="SourceAlpha" result="effect1_innerShadow_1319_8572" />
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="3" />
					<feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
					<feColorMatrix type="matrix" values="0 0 0 0 0.320651 0 0 0 0 0.275129 0 0 0 0 0.600282 0 0 0 0.21 0" />
					<feBlend mode="normal" in2="shape" result="effect1_innerShadow_1319_8572" />
				</filter>
			</defs>
		</svg.SVG>
	)
}

export const retry = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="15px" height="15px" viewBox="0 0 15 15" version="1.1" {...rest}>
			<path d="M 11.03125 3.96875 C 10.128906 3.0625 8.882812 2.5 7.5 2.5 C 4.738281 2.5 2.507812 4.738281 2.507812 7.5 C 2.507812 10.261719 4.738281 12.5 7.5 12.5 C 9.828125 12.5 11.777344 10.90625 12.332031 8.75 L 11.03125 8.75 C 10.515625 10.207031 9.132812 11.25 7.5 11.25 C 5.429688 11.25 3.75 9.570312 3.75 7.5 C 3.75 5.429688 5.429688 3.75 7.5 3.75 C 8.535156 3.75 9.460938 4.179688 10.140625 4.859375 L 8.125 6.875 L 12.5 6.875 L 12.5 2.5 Z M 11.03125 3.96875 " />
		</svg.SVG>
	)
}

export const checkbox = (props: checkboxIconProps) => {
	let { checked, fill, stroke, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="19" height="16" viewBox="0 0 19 16" fill="none" {...rest}>
			<rect
				x="0.25"
				y="1.25"
				width="14.5"
				height="14.5"
				rx="0.75"
				fill={fill || theme.colors.grey.light50}
				stroke={theme.colors.white}
				strokeWidth="0.5"
			/>
			{checked && (
				<path
					d="M4.5 7.75L7.5 11.5L17.25 1"
					stroke={stroke || theme.colors.blue.blue}
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			)}
		</svg.SVG>
	)
}

export const download = (props: svg.SVGProps) => {
	let { stroke, ...rest } = props
	return (
		<svg.SVG width="28" height="28" viewBox="0 0 28 28" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8 15.8143L8 18.4779C8 18.8816 8.15804 19.2687 8.43934 19.5542C8.72064 19.8396 9.10218 20 9.5 20H18.5C18.8978 20 19.2794 19.8396 19.5607 19.5542C19.842 19.2687 20 18.8816 20 18.4779V15.8143M14.0008 7V15.6251M14.0008 15.6251L17.4294 12.3295M14.0008 15.6251L10.5723 12.3295"
				stroke={stroke || theme.colors.blue.blue}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<circle cx="14" cy="14" r="13.5" stroke={stroke || theme.colors.blue.blue} />
		</svg.SVG>
	)
}

export const remove = (props: svg.SVGProps) => {
	let { stroke, ...rest } = props
	return (
		<svg.SVG width="28" height="28" viewBox="0 0 28 28" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
			<circle cx="14" cy="14" r="13.5" stroke={stroke || theme.colors.blue.blue} />
			<path
				d="M9 10.0647H19.4M12.9 16.9471V12.8176M15.5 16.9471V12.8176M16.8 19.7H11.6C10.882 19.7 10.3 19.0837 10.3 18.3235V10.7529C10.3 10.3728 10.591 10.0647 10.95 10.0647H17.45C17.809 10.0647 18.1 10.3728 18.1 10.7529V18.3235C18.1 19.0837 17.518 19.7 16.8 19.7ZM12.9 10.0647H15.5C15.859 10.0647 16.15 9.75657 16.15 9.37647V8.68824C16.15 8.30813 15.859 8 15.5 8H12.9C12.541 8 12.25 8.30813 12.25 8.68824V9.37647C12.25 9.75657 12.541 10.0647 12.9 10.0647Z"
				stroke={stroke || theme.colors.blue.blue}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

export const scoregood = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG
			xmlns="http://www.w3.org/2000/svg"
			width="70"
			height="71"
			viewBox="0 0 70 71"
			fill={theme.colors.grey.light50}
			fillOpacity="0.2"
			{...rest}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.1592 0C9.03672 6.42202 0 19.9057 0 35.5C0 51.0943 9.03672 64.578 22.1592 71H56.8408C61.9414 68.5038 66.4247 64.9408 70 60.6016V43.4045C66.4929 56.9757 54.1671 67 39.5 67C22.103 67 8 52.897 8 35.5C8 18.103 22.103 4 39.5 4C54.1671 4 66.4929 14.0243 70 27.5955V10.3984C66.4247 6.05924 61.9414 2.49618 56.8408 0H22.1592ZM54.7219 30.3725C56.284 28.8104 56.284 26.2777 54.7219 24.7156C53.1598 23.1535 50.6271 23.1535 49.065 24.7156L35.0625 38.7181L32.1537 35.8094C30.5916 34.2473 28.059 34.2473 26.4969 35.8094C24.9348 37.3715 24.9348 39.9041 26.4969 41.4662L32.2341 47.2034C33.7962 48.7655 36.3288 48.7655 37.8909 47.2034L54.7219 30.3725Z"
				fill={theme.colors.grey.light50}
				fillOpacity="0.2"
			/>
		</svg.SVG>
	)
}

export const scorebad = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG
			xmlns="http://www.w3.org/2000/svg"
			width="69"
			height="71"
			viewBox="0 0 69 71"
			fill={theme.colors.grey.light50}
			fillOpacity="0.16"
			{...rest}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.81348 34C8.81348 15.7328 23.4476 1 41.4069 1C53.0084 1 63.2223 7.14802 69 16.4253V3.92788C67.4721 2.4966 65.8348 1.18254 64.102 0H18.7118C7.90501 7.37487 0.813477 19.8654 0.813477 34C0.813477 50.2862 10.2283 64.3897 23.8932 71H58.9206C62.6275 69.2068 66.0217 66.8622 69 64.0721V51.5747C63.2223 60.852 53.0084 67 41.4069 67C23.4476 67 8.81348 52.2672 8.81348 34ZM31.3132 18.1058C29.7597 16.5351 27.2271 16.5211 25.6564 18.0745C24.0857 19.628 24.0717 22.1606 25.6251 23.7313L35.781 34L25.6251 44.2687C24.0717 45.8394 24.0857 48.372 25.6564 49.9255C27.2271 51.4789 29.7597 51.4649 31.3132 49.8942L41.4069 39.6884L51.5006 49.8942C53.054 51.4649 55.5867 51.4789 57.1574 49.9255C58.7281 48.372 58.7421 45.8394 57.1886 44.2687L47.0327 34L57.1886 23.7313C58.7421 22.1606 58.7281 19.628 57.1574 18.0745C55.5867 16.5211 53.054 16.5351 51.5006 18.1058L41.4069 28.3116L31.3132 18.1058Z"
				fill={theme.colors.grey.light50}
				fillOpacity="0.16"
			/>
		</svg.SVG>
	)
}

export const info = (props: svg.SVGProps) => {
	let { fill, ...rest } = props
	return (
		<svg.SVG xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none" {...rest}>
			<path
				d="M3.9996 0C6.20898 0 8 1.79102 8 4.0004C8 6.20938 6.20898 8 3.9996 8C1.79022 8.0004 6.69894e-08 6.20938 6.69894e-08 4.0004C-0.000399893 1.79102 1.79022 0 3.9996 0ZM3.998 3.29967C3.89998 3.2998 3.80543 3.33593 3.73229 3.40118C3.65915 3.46643 3.61251 3.55627 3.60124 3.65363L3.59844 3.70003L3.60004 5.90061L3.60244 5.94701C3.61362 6.04456 3.66029 6.13459 3.73357 6.19995C3.80685 6.26532 3.90161 6.30144 3.9998 6.30144C4.09799 6.30144 4.19275 6.26532 4.26603 6.19995C4.33931 6.13459 4.38598 6.04456 4.39716 5.94701L4.39956 5.90021L4.39796 3.69963L4.39516 3.65283C4.3836 3.55555 4.33673 3.46589 4.26345 3.40086C4.19017 3.33584 4.09597 3.29957 3.998 3.29967ZM4 1.80022C3.86725 1.80022 3.73993 1.85296 3.64606 1.94683C3.55219 2.0407 3.49945 2.16802 3.49945 2.30077C3.49945 2.43352 3.55219 2.56084 3.64606 2.65471C3.73993 2.74858 3.86725 2.80132 4 2.80132C4.06571 2.80129 4.13076 2.78833 4.19146 2.76316C4.25216 2.73799 4.3073 2.70111 4.35374 2.65463C4.40018 2.60815 4.43702 2.55298 4.46214 2.49226C4.48726 2.43155 4.50018 2.36648 4.50015 2.30077C4.50012 2.23506 4.48716 2.17 4.46199 2.10931C4.43682 2.04861 4.39994 1.99347 4.35346 1.94703C4.30698 1.90058 4.25181 1.86375 4.19109 1.83863C4.13038 1.81351 4.06571 1.80019 4 1.80022Z"
				fill={fill}
				fillOpacity="0.15"
			/>
		</svg.SVG>
	)
}

info.defaultProps = {
	fill: theme.colors.grey.dark50,
}

export const flag = (props: svg.SVGProps) => {
	let { ...rest } = props
	return (
		<svg.SVG
			version="1.1"
			id="Icons"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 32 32"
			xmlSpace="preserve"
			{...rest}
		>
			<path
				d="M26.5,4.8c-0.3-0.2-0.7-0.2-1,0c-3.5,2.2-6.1,0.8-9-0.8c-3-1.6-6.5-3.4-11-0.7C5.2,3.6,5,3.9,5,4.3V18v0.3V29
	c0,0.6,0.4,1,1,1s1-0.4,1-1V18.9c3.3-1.8,5.7-0.5,8.5,1c1.9,1,4,2.1,6.4,2.1c1.4,0,3-0.4,4.6-1.4c0.3-0.2,0.5-0.5,0.5-0.9v-14
	C27,5.3,26.8,5,26.5,4.8z"
			/>
		</svg.SVG>
	)
}

export const image = (props: svg.SVGProps) => {
	let { fill, ...rest } = props
	return (
		<svg.SVG width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M9.51103 10.0767C9.70796 10.2703 10.0245 10.2676 10.2181 10.0706C10.4117 9.8737 10.409 9.55712 10.212 9.36354L9.51103 10.0767ZM6.72331 6.63523L6.3725 6.99151L6.3728 6.9918L6.72331 6.63523ZM5.20473 6.59091L4.87562 6.2145L4.87534 6.21474L5.20473 6.59091ZM0.670612 9.89656C0.462859 10.0785 0.441914 10.3944 0.62383 10.6021C0.805746 10.8099 1.12164 10.8308 1.32939 10.6489L0.670612 9.89656ZM6.74146 12.6438C6.54472 12.8375 6.5423 13.1541 6.73607 13.3508C6.92983 13.5476 7.2464 13.55 7.44315 13.3562L6.74146 12.6438ZM11.3618 8.79523L11.7126 9.15147L11.713 9.15112L11.3618 8.79523ZM12.854 8.72705L13.1714 8.34067L13.1708 8.34021L12.854 8.72705ZM15.0826 11.2046C15.296 11.3798 15.6111 11.3489 15.7864 11.1355C15.9616 10.9221 15.9307 10.6071 15.7174 10.4318L15.0826 11.2046ZM2.66154 1.5H13.7385V0.5H2.66154V1.5ZM13.7385 1.5C14.3872 1.5 14.9 2.01594 14.9 2.63636H15.9C15.9 1.44931 14.925 0.5 13.7385 0.5V1.5ZM14.9 2.63636V11.3636H15.9V2.63636H14.9ZM14.9 11.3636C14.9 11.9841 14.3872 12.5 13.7385 12.5V13.5C14.925 13.5 15.9 12.5507 15.9 11.3636H14.9ZM13.7385 12.5H2.66154V13.5H13.7385V12.5ZM2.66154 12.5C2.01281 12.5 1.5 11.9841 1.5 11.3636H0.5C0.5 12.5507 1.47498 13.5 2.66154 13.5V12.5ZM1.5 11.3636V2.63636H0.5V11.3636H1.5ZM1.5 2.63636C1.5 2.01594 2.01281 1.5 2.66154 1.5V0.5C1.47498 0.5 0.5 1.44931 0.5 2.63636H1.5ZM11.5769 4.27273C11.5769 4.59191 11.3121 4.86364 10.9692 4.86364V5.86364C11.8499 5.86364 12.5769 5.15853 12.5769 4.27273H11.5769ZM10.9692 4.86364C10.6264 4.86364 10.3615 4.59191 10.3615 4.27273H9.36154C9.36154 5.15853 10.0886 5.86364 10.9692 5.86364V4.86364ZM10.3615 4.27273C10.3615 3.95355 10.6264 3.68182 10.9692 3.68182V2.68182C10.0886 2.68182 9.36154 3.38692 9.36154 4.27273H10.3615ZM10.9692 3.68182C11.3121 3.68182 11.5769 3.95355 11.5769 4.27273H12.5769C12.5769 3.38692 11.8499 2.68182 10.9692 2.68182V3.68182ZM10.212 9.36354L7.07382 6.27866L6.3728 6.9918L9.51103 10.0767L10.212 9.36354ZM7.07411 6.27895C6.78372 5.99302 6.3949 5.82837 5.98753 5.81649L5.95836 6.81606C6.11552 6.82065 6.2635 6.88419 6.3725 6.99151L7.07411 6.27895ZM5.98753 5.81649C5.58019 5.8046 5.1824 5.94626 4.87562 6.2145L5.53384 6.96732C5.6494 6.86629 5.8012 6.81147 5.95836 6.81606L5.98753 5.81649ZM4.87534 6.21474L0.670612 9.89656L1.32939 10.6489L5.53412 6.96708L4.87534 6.21474ZM7.44315 13.3562L11.7126 9.15147L11.0109 8.43899L6.74146 12.6438L7.44315 13.3562ZM11.713 9.15112C11.8195 9.04596 11.9636 8.98261 12.1173 8.97558L12.0717 7.97663C11.6731 7.99484 11.2945 8.15913 11.0106 8.43934L11.713 9.15112ZM12.1173 8.97558C12.271 8.96856 12.4208 9.01852 12.5372 9.11388L13.1708 8.34021C12.8622 8.08747 12.4701 7.95842 12.0717 7.97663L12.1173 8.97558ZM12.5367 9.11342L15.0826 11.2046L15.7174 10.4318L13.1714 8.34067L12.5367 9.11342Z"
				fill={fill}
			/>
		</svg.SVG>
	)
}

image.defaultProps = {
	fill: theme.colors.grey.dark50,
	fillOpacity: "1",
}

export const text = (props: svg.SVGProps) => {
	let { stroke, strokeOpacity, ...rest } = props
	return (
		<svg.SVG width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M4.33333 5.33333V4.33333H9.66667V5.33333M6.33333 10.3333H7.66667M7 5V10.3333M2 1H12C12.5523 1 13 1.44772 13 2V12C13 12.5523 12.5523 13 12 13H2C1.44772 13 1 12.5523 1 12V2C1 1.44772 1.44772 1 2 1Z"
				stroke={stroke}
				strokeOpacity={strokeOpacity}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

text.defaultProps = {
	stroke: theme.colors.grey.dark50,
	strokeOpacity: "1",
}

export const document = (props: svg.SVGProps) => {
	let { stroke, strokeOpacity, ...rest } = props
	return (
		<svg.SVG width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M8 1H2C1.44772 1 1 1.44772 1 2V14C1 14.5523 1.44772 15 2 15H12C12.5523 15 13 14.5523 13 14V6M8 1L13 6M8 1V5C8 5.55228 8.44772 6 9 6H13M4 8H10M4 11H10"
				stroke={stroke}
				strokeOpacity={strokeOpacity}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

document.defaultProps = {
	stroke: theme.colors.grey.dark50,
	strokeOpacity: "1",
}

export const video = (props: svg.SVGProps) => {
	let { stroke, strokeOpacity, ...rest } = props
	return (
		<svg.SVG width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
			<path
				d="M10.5 5.5L14 3V11L10.5 8.5M2 2.5H9.5C10.0523 2.5 10.5 2.94772 10.5 3.5V10.5C10.5 11.0523 10.0523 11.5 9.5 11.5H2C1.44772 11.5 1 11.0523 1 10.5V3.5C1 2.94772 1.44772 2.5 2 2.5Z"
				stroke={stroke}
				strokeOpacity={strokeOpacity}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg.SVG>
	)
}

video.defaultProps = {
	stroke: theme.colors.grey.dark50,
	strokeOpacity: "1",
}

export default Icon
